function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _create_class(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else obj[key] = value;
  return obj;
}
var unavailable = function unavailable2() {
  throw new Error("MessageUI needs an iOS build");
};
var MFMailComposeViewController = /* @__PURE__ */ (function() {
  "use strict";
  function MFMailComposeViewController2() {
    _class_call_check(this, MFMailComposeViewController2);
    _define_property(this, "mailComposeDelegate", null);
  }
  _create_class(MFMailComposeViewController2, [
    {
      key: "setSubject",
      value: function setSubject(_subject) {
        unavailable();
      }
    },
    {
      key: "setToRecipients",
      value: function setToRecipients(_recipients) {
        unavailable();
      }
    },
    {
      key: "setCcRecipients",
      value: function setCcRecipients(_recipients) {
        unavailable();
      }
    },
    {
      key: "setBccRecipients",
      value: function setBccRecipients(_recipients) {
        unavailable();
      }
    },
    {
      key: "setMessageBody",
      value: function setMessageBody(_body, _isHTML) {
        unavailable();
      }
    },
    {
      key: "setPreferredSendingEmailAddress",
      value: function setPreferredSendingEmailAddress(_emailAddress) {
        unavailable();
      }
    },
    {
      key: "addAttachmentData",
      value: function addAttachmentData(_attachment, _mimeType, _fileName) {
        unavailable();
      }
    },
    {
      key: "present",
      value: async function present() {
        var _animated = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        unavailable();
      }
    },
    {
      key: "dismiss",
      value: async function dismiss() {
        var _animated = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        unavailable();
      }
    }
  ], [
    {
      key: "canSendMail",
      value: function canSendMail() {
        return false;
      }
    }
  ]);
  return MFMailComposeViewController2;
})();
var MFMessageComposeViewController = /* @__PURE__ */ (function() {
  "use strict";
  function MFMessageComposeViewController2() {
    _class_call_check(this, MFMessageComposeViewController2);
    _define_property(this, "messageComposeDelegate", null);
    _define_property(this, "recipients", void 0);
    _define_property(this, "body", void 0);
    _define_property(this, "subject", void 0);
  }
  _create_class(MFMessageComposeViewController2, [
    {
      key: "attachments",
      get: function get() {
        return [];
      }
    },
    {
      key: "disableUserAttachments",
      value: function disableUserAttachments() {
        unavailable();
      }
    },
    {
      key: "addAttachmentData",
      value: function addAttachmentData(_attachment, _typeIdentifier, _filename) {
        return unavailable();
      }
    },
    {
      key: "addAttachmentURL",
      value: function addAttachmentURL(_attachmentURL, _withAlternateFilename) {
        return unavailable();
      }
    },
    {
      key: "present",
      value: async function present() {
        var _animated = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        unavailable();
      }
    },
    {
      key: "dismiss",
      value: async function dismiss() {
        var _animated = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        unavailable();
      }
    }
  ], [
    {
      key: "canSendText",
      value: function canSendText() {
        return false;
      }
    },
    {
      key: "canSendAttachments",
      value: function canSendAttachments() {
        return false;
      }
    },
    {
      key: "canSendSubject",
      value: function canSendSubject() {
        return false;
      }
    },
    {
      key: "isSupportedAttachmentUTI",
      value: function isSupportedAttachmentUTI(_uti) {
        return false;
      }
    }
  ]);
  return MFMessageComposeViewController2;
})();
export {
  MFMailComposeViewController,
  MFMessageComposeViewController
};
//# sourceMappingURL=unavailable.js.map
